export default __webpack_public_path__ + "static/media/footer-logo.a8e791cf.png";